import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { createSellerEvent, editSellerEvent } from '../../../_events/users/create_user.event';
import { findAllUsersEvent } from '../../../_events/users/find_users.event';
import { findAllRolesEvent } from '../../../_events/roles/find_roles.event';
import { message } from "antd";
import { ROLES } from "../../../_config/roles";
import RolWrapper from "../../hoc/roles_wrapper";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.admin]);

const Users = () => {

    const [render, setRender] = useState('info');
    const [item, setItem] = useState(null);

    const columns = [
        { field: 'rol.name', headerName: 'Rol', width: 200, sortable: false,
            renderCell: (params) => {
                return <span>{params.row.rol?.name}</span>;
            }
        },
        { field: 'full_name', headerName: 'Nombre', width: 200 },
        { field: 'login', headerName: 'Usuario', width: 200 },
        { field: 'state.cod', headerName: 'Estado', width: 100, sortable: false,
            renderCell: (params) => {
                return <span style={params.row.state?.cod === 'ACTI' ? {color: 'green'} : {}}>{params.row.state?.name}</span>;
            }
        },
        { field: '', headerName: 'Acciones', width: 100, sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setItem(params.row); setRender('form');
                };    
                return <ButtonRolAuthComponent onClick={onClick}>Editar</ButtonRolAuthComponent>;
            }
        },
    ];

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Usuarios
                    </Typography>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'100%'}}>
                        {
                            render === 'info' ? 
                            <ButtonRolAuthComponent onClick={() => {setItem(null);setRender('form');}} variant="contained">Crear nuevo</ButtonRolAuthComponent>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                {
                    render === 'info' ? <Info columns={columns} /> : <Form item={item} />
                }                
            </Grid>
        </Grid>
    );
}

const Info = (props) => {

    const [users, setUsers] = useState([]);

    const findUsers = () => {
        findAllUsersEvent()
        .then(data => {
            setUsers(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findUsers();
    }, []);   

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={users}
                columns={props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

const Form = (props) => {
    const [roles, setRoles] = React.useState([]);
    let { item } = props; 

    React.useEffect(() => {
        findAllRolesEvent()
        .then(data => {
            setRoles(data.list.filter(r => r.cod !== 'SELL'));
        })
        .catch(err => {
            message.error(err.message);
        });
    },[]);

    const createSeller = () => {
        createSellerEvent()
        .then(data => {
            message.success('Creado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const editSeller = (id) => {
        editSellerEvent(id)
        .then(data => {
            message.success('Actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="user_full_name" 
                        label="Nombre completo" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.full_name : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="user_login" 
                        label="Usario en el sistema" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.login : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                        <span style={{alignItems: 'center', justifyContent: 'center', marginRight: '10px'}}>Rol:</span>
                        <select style={{width: '100%', height: '40px'}} id="user_rol" >
                            {
                                roles.map((r, key) => {
                                    return(
                                        <option key={key} value={r.cod} selected={item ? item.rol.cod === r.cod ? true : false : false}>
                                            {r.name}
                                        </option>
                                    );
                                })
                            }
                        </select> 
                    </div>    
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        type={'password'}
                        style={{width: '100%'}} 
                        id="user_password" 
                        label="Contraseña" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.password : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        item ? <Button style={{width: '100%'}} onClick={() => editSeller(item.uuid)} variant="contained">Editar</Button>
                        : <Button style={{width: '100%'}} onClick={() => createSeller()} variant="contained">Guardar</Button>
                    }      
                </Grid>                
            </Grid>
        </div>
    );
}

export default Users;